@if (result && !state.quickEditEnabled) {
  <rt-box variant="default vertical no-padding" margin-bottom>
    <ng-container *ngTemplateOutlet="cardHeader; context: { $implicit: controlsTpl }">
    </ng-container>
    @if (result.ratingNote) {
      <rt-divider></rt-divider>
      <div padding>
        @if (state.answers && state.answers.length) {
          <rt-heading>
            {{ 'app.interview.summary.summary' | translate }}
          </rt-heading>
        }
        <div [innerHTML]="sanitizedNote"></div>
      </div>
    }
    @if (state.answers && state.answers.length) {
      <rt-divider></rt-divider>
      <div
        #cardBody
        [class.collapsed]="!state.showMore && state.showMoreEnabled"
        class="box-body"
        padding
      >
        <rt-interview-answer-list
          [answers]="state.answers"
          [canManageCandidates]="!!abilities?.manageCandidates"
          [ratingLevelTranslations]="ratingLevelTranslations"
        >
        </rt-interview-answer-list>
        @if (state.showMoreEnabled) {
          <div>
            <rt-button (click)="toggleShowMore()" variant="tertiary" class="show-more" margin-top>
              {{ (state.showMore ? 'app.common.show_less' : 'app.common.show_more') | translate }}
            </rt-button>
          </div>
        }
      </div>
    }
    @if (isFairEvalEnabledForStage) {
      <rt-divider></rt-divider>
      <rt-box
        class="no-padding no-border"
        layout-align-items-center
        padding-left
        padding-top-small-x
        padding-bottom-small-x
        padding-right
      >
        <div>{{ 'app.pricing.plan_picker.features.fair_evaluations' | translate }}</div>
        <rt-divider variant="dot" class="footer-dot-divider"></rt-divider>
        <div>{{ 'app.interview.unhidden_for_you' | translate }}</div>
      </rt-box>
    }
  </rt-box>
}

@if (edit && state.quickEditEnabled) {
  <rt-quick-evaluation-form
    [result]="result"
    [assignedPlacement]="assignedPlacement"
    [headerTpl]="cardHeader"
    (close)="close()"
  >
  </rt-quick-evaluation-form>
}

<ng-template #controlsTpl>
  <div
    [attr.margin-top-small]="!hasHeader ? '' : null"
    class="card-container"
    layout-horizontal
    padding-lr
  >
    <div class="fixed-100" padding-right layout layout-align-items-center>
      <rt-interview-evaluation-rating
        [rating]="result.rating"
        [stage]="result.stage ? result.stage.name : null"
        [offer]="(result.offer || result.talentPool)!"
        [tooltip]="false"
        [translations]="ratingLevelTranslations"
        variant="hasLabel"
      >
      </rt-interview-evaluation-rating>
    </div>
    <div padding-left border-left layout layout-align-items-center layout-full-width layout-flex-1>
      <rt-interview-member [result]="result"></rt-interview-member>
      <div class="actions" layout-horizontal layout-justify-flex-end layout-align-items-center>
        @if (edit) {
          <rt-group margin-left-small-xx>
            @if (canEdit()) {
              <rt-icon-button
                (click)="editInterviewResult()"
                variant="plain"
                iconName="edit"
                shape="square"
              >
              </rt-icon-button>
            }
          </rt-group>
        }
        @if (abilities?.highLevelDataAccess || (result.guestId && abilities?.viewCandidates)) {
          <rt-group margin-left-small-xx>
            @if (!result.guestId || (result.guestId && abilities?.manageCandidates)) {
              <rt-icon-button
                [loading]="state.deleteLoading"
                (click)="delete()"
                class="delete-btn danger-on-hover"
                variant="plain"
                iconName="delete"
                shape="square"
              >
              </rt-icon-button>
            }
          </rt-group>
        }
      </div>
    </div>
  </div>
</ng-template>
<ng-template #cardHeader let-controls>
  <div
    [class.has-header]="hasHeader"
    [attr.padding-bottom-small]="!!controls ? '' : null"
    class="box-header"
  >
    @if (hasHeader) {
      <div class="completed-header" padding-lr-small-x padding-tb-small-x>
        <div class="header-line">
          @if (result.candidate.isAnonymous) {
            <rt-avatar
              [shape]="'oval'"
              size="small-x"
              type="icon"
              iconName="visibility-off"
              customIconBackgroundColor="colorAvatarSteelLighter"
              customIconColor="colorIconDisabled"
              margin-left-small-xx
              margin-right-small-x
            ></rt-avatar>
          } @else {
            <rt-avatar
              [type]="result.candidate.hasAvatar ? 'image' : 'initials'"
              [initials]="result.candidate.initials"
              [size]="'small-x'"
              [shape]="'oval'"
              [imageSrc]="result.candidate.photoThumbUrl"
              margin-left-small-xx
              margin-right-small-x
            >
            </rt-avatar>
          }
          <div class="candidate-name-and-offer">
            <div class="candidate-name" (click)="openCandidate(result)">
              {{ result.candidate.name }}
            </div>
            @if (result.offer || result.talentPool; as resultOffer) {
              <div class="offer">
                <rt-offer-status-indicator [offerStatus]="resultOffer" margin-left-small-xx>
                </rt-offer-status-indicator>
                <span (click)="openOffer(result)">{{ resultOffer.title }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if (hasHeader) {
      <rt-divider [attr.margin-bottom-small]="!!controls ? '' : null"> </rt-divider>
    }
    <ng-container *ngTemplateOutlet="controls"></ng-container>
  </div>
</ng-template>
